/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { ClosedEnum } from "../../types/enums.js";

/**
 * The type of hook event
 */
export const CodexHookPayloadHookEventName = {
  SessionStart: "SessionStart",
  PreToolUse: "PreToolUse",
  PermissionRequest: "PermissionRequest",
  PostToolUse: "PostToolUse",
  UserPromptSubmit: "UserPromptSubmit",
  Stop: "Stop",
} as const;
/**
 * The type of hook event
 */
export type CodexHookPayloadHookEventName = ClosedEnum<
  typeof CodexHookPayloadHookEventName
>;

/**
 * Payload for Codex hook events
 */
export type CodexHookPayload = {
  /**
   * Additional hook-specific data
   */
  additionalData?: { [k: string]: any } | undefined;
  /**
   * The working directory when the event fired
   */
  cwd?: string | undefined;
  /**
   * The type of hook event
   */
  hookEventName: CodexHookPayloadHookEventName;
  /**
   * The final assistant message text for the turn (Stop only)
   */
  lastAssistantMessage?: string | undefined;
  /**
   * The model identifier
   */
  model?: string | undefined;
  /**
   * The type of permission being requested (PermissionRequest only)
   */
  permissionType?: string | undefined;
  /**
   * The user's prompt text (UserPromptSubmit only)
   */
  prompt?: string | undefined;
  /**
   * The Codex session ID
   */
  sessionId?: string | undefined;
  /**
   * The input to the tool (PreToolUse only)
   */
  toolInput?: any | undefined;
  /**
   * The name of the tool
   */
  toolName?: string | undefined;
  /**
   * The output from the tool (PostToolUse only)
   */
  toolOutput?: any | undefined;
  /**
   * Path to the conversation transcript file
   */
  transcriptPath?: string | undefined;
  /**
   * Email of the authenticated Codex user, if available
   */
  userEmail?: string | undefined;
};

/** @internal */
export const CodexHookPayloadHookEventName$outboundSchema: z.ZodMiniEnum<
  typeof CodexHookPayloadHookEventName
> = z.enum(CodexHookPayloadHookEventName);

/** @internal */
export type CodexHookPayload$Outbound = {
  additional_data?: { [k: string]: any } | undefined;
  cwd?: string | undefined;
  hook_event_name: string;
  last_assistant_message?: string | undefined;
  model?: string | undefined;
  permission_type?: string | undefined;
  prompt?: string | undefined;
  session_id?: string | undefined;
  tool_input?: any | undefined;
  tool_name?: string | undefined;
  tool_output?: any | undefined;
  transcript_path?: string | undefined;
  user_email?: string | undefined;
};

/** @internal */
export const CodexHookPayload$outboundSchema: z.ZodMiniType<
  CodexHookPayload$Outbound,
  CodexHookPayload
> = z.pipe(
  z.object({
    additionalData: z.optional(z.record(z.string(), z.any())),
    cwd: z.optional(z.string()),
    hookEventName: CodexHookPayloadHookEventName$outboundSchema,
    lastAssistantMessage: z.optional(z.string()),
    model: z.optional(z.string()),
    permissionType: z.optional(z.string()),
    prompt: z.optional(z.string()),
    sessionId: z.optional(z.string()),
    toolInput: z.optional(z.any()),
    toolName: z.optional(z.string()),
    toolOutput: z.optional(z.any()),
    transcriptPath: z.optional(z.string()),
    userEmail: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      additionalData: "additional_data",
      hookEventName: "hook_event_name",
      lastAssistantMessage: "last_assistant_message",
      permissionType: "permission_type",
      sessionId: "session_id",
      toolInput: "tool_input",
      toolName: "tool_name",
      toolOutput: "tool_output",
      transcriptPath: "transcript_path",
      userEmail: "user_email",
    });
  }),
);

export function codexHookPayloadToJSON(
  codexHookPayload: CodexHookPayload,
): string {
  return JSON.stringify(
    CodexHookPayload$outboundSchema.parse(codexHookPayload),
  );
}
